import styled from 'styled-components';

import { hexToRGB } from '@/styles/helpers';

export interface ScDashboardPanelPopupProps {
  isMobile?: boolean;
}

export const ScDashboardPanelPopup = styled.div<ScDashboardPanelPopupProps>`
  padding: 16px;
  background-color: ${({ theme }) => theme.grayLightColor};
  border-radius: 16px;
  box-sizing: border-box;
  width: ${({ isMobile }) => (isMobile ? '100%' : '342px')};
  position: relative;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.9);

  .divider {
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.1)};
    margin: 16px 0;
  }

  .user-block {
    & > div {
      padding: 0;

      .value {
        padding: 0;
      }
    }
  }
`;
